import { Text, tokens } from '@fluentui/react-components';
import { useMobileOtherInfo } from './MobileOtherInfoContext';
import { CompletionCount } from './CompletionCount';
import { CompletionBadge } from './CompletionBadge';

export const SectionHeader = () => {
  const { currentTab, getTabCompletion } = useMobileOtherInfo();

  if (!currentTab) return null;

  const { completedFields, totalFields } = getTabCompletion(currentTab);

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        padding: '12px 16px',
        backgroundColor: tokens.colorBrandBackground,
        color: tokens.colorNeutralForegroundOnBrand,
        borderRadius: 6,
      }}
    >
      <Text weight="semibold" size={400} style={{ color: 'inherit', flex: 1 }}>
        {currentTab.caption}
      </Text>
      <CompletionCount
        completedFields={completedFields}
        totalFields={totalFields}
        onBrand
      />
      <CompletionBadge
        completedFields={completedFields}
        totalFields={totalFields}
      />
    </div>
  );
};
